<template>
	<transition name="modal">
		<div class="modal-mask" tabindex="-1" role="dialog" aria-hidden="true" style="display: block" v-show="show" @click="show = false">
			<div class="modal-dialog modal-lg" @click.stop>
				<div class="modal-content">
					<div class="modal-header">
						<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0px">
							<h5 class="modal-title" id="dynvibeGraphDetailsTitle">
								<span class="dynvibeModalTitle">Graph details</span>
								<button
									type="button"
									class="close"
									data-dismiss="modal"
									aria-label="Close"
									style="outline: 0"
									@click="show = false"
								>
									<span aria-hidden="true"><i class="icon-x"></i></span>
								</button>
							</h5>
						</div>
					</div>
					<div class="modal-body">
						<div role="tabpanel">
							<div v-if="mode === 'word' && event && !idauthor">
								<div id="dynvibeDetailsWordCloud" class="col-lg-12">
									<div class="dynvibeTagClass">
										<select
											class="form-control dynvibeSelect dynvibeTagClass"
											name="dynvibeTagClass"
											style="color: #ef202e; background-color: #e9e7e6"
											v-model="tagclassSelected"
										>
											<option v-for="(option, index) in tagclass" v-bind:value="option.value" :key="index">
												{{ option.text }}
											</option>
										</select>
									</div>
									<dynvibewordcloud
										ref="wordcloudEventsRelative"
										axios="wordcloudEventsRelative"
										:event-relative="true"
										@reloadoutergraphdetail="reloadFromWordcloudEvent($event)"
									></dynvibewordcloud>
								</div>
							</div>
							<!-- Nav tabs -->
							<ul class="nav nav-tabs" role="tablist">
								<li role="presentation" class="nav-item" v-bind:class="{ active: openTab === 'stories' }">
									<a
										class="nav-link"
										:href="'#storiesTab-' + axios"
										:aria-controls="'storiesTab-' + axios"
										role="tab"
										data-toggle="tab"
										@click="
											reloadInnerWordcloud();
											openTab = 'stories';
										"
										>STORIES</a
									>
								</li>
								<li role="presentation" class="nav-item" v-bind:class="{ active: openTab === 'profiles' }">
									<a
										v-if="!idauthor"
										class="nav-link"
										:href="'#profilesTab-' + axios"
										@click="openTab = 'profiles'"
										:aria-controls="'profilesTab-' + axios"
										role="tab"
										data-toggle="tab"
										>PROFILES</a
									>
								</li>
							</ul>
							<div class="tab-content">
								<div
									role="tabpanel"
									class="tab-pane"
									v-bind:class="{ active: openTab === 'profiles' }"
									:id="'profilesTab-' + axios"
								>
									<div class="row dynvibeRow" style="margin-top: 10px">
										<div class="col-xs-12">
											<p class="graphDetailsTotal dynvibeGalleryProfilesTotal">
												Total profiles : {{ totalProfiles }}
											</p>

											<listprofilecircles
												v-if="totalProfiles > 0"
												:profiles="profiles"
												:ref="'profilescircles-' + axios"
												:point-id="profilesPointId"
											></listprofilecircles>
										</div>
									</div>
								</div>
								<div
									role="tabpanel"
									class="tab-pane"
									v-bind:class="{ active: openTab === 'stories' }"
									:id="'storiesTab-' + axios"
								>
									<div class="row dynvibePaginationGraphdetail">
										<div class="col-lg-12">
											<div style="float: right; margin-top: 10px">
												<pagination
													v-if="page >= 0"
													:page="page"
													:page-max="pageMax"
													@changepage="changePostPage($event)"
												></pagination>
											</div>
											<p v-if="orderBy !== 'authors' || idauthor" class="dynvibeStoryListDetailsTotalStories">
												Total posts : {{ totalPosts }}
											</p>
											<p v-else-if="orderBy === 'authors'" class="dynvibeStoryListDetailsTotalStories">
												Total authors : {{ totalProfiles }}
											</p>
											<perpagesort
												ref="perpagesort"
												:size="false"
												@changesort="changeSortPage"
												@changerange="changeRangePage"
												:sortable="!idauthor"
											></perpagesort>
										</div>
									</div>

									<div v-if="orderBy !== 'authors' || idauthor" class="row dynvibeRow">
										<div>
											<p v-if="idauthor && mode !== 'story'" style="text-align: center">
												<button @click="backToPreviousGraph()" id="backToPreviousGraph">
													BACK TO PREVIOUS GRAPH DETAILS
												</button>
											</p>
										</div>
										<div v-if="!noData" class="col-lg-12 dynvibeListPosts dynvibeBox" style="margin: 10px 0px">
											<bigstory
												:showfiche="false"
												:ref="'story-' + post._id"
												v-for="(post, postId) in resultsPosts"
												v-bind:key="postId"
												:post="post"
												:post_id="postId"
												:middle="middle"
												:editrule="false"
											></bigstory>
										</div>
										<div v-else class="dynvibeLoading" style="min-height: 295px"></div>
									</div>
									<div v-if="orderBy === 'authors' && !idauthor" class="row dynvibeRow" style="margin-top: 20px">
										<div class="col-xs-12" style="margin-top: 10px">
											<div class="dynvibeBox" style="margin: 10px 0px">
												<div
													v-for="(profile, index) in resultsPosts"
													v-bind:key="index"
													class="col-xs-12 dynvibeStory"
													style="padding-bottom: 0px; padding-top: 0px"
												>
													<div class="col-xs-2" style="position: sticky; top: 0px">
														<div style="padding: 15px 0px">
															<p style="margin-bottom: 0px">
																Author n°<span style="font-weight: 500">{{ from + index + 1 }}</span>
															</p>
															<p style="font-style: italic">( {{ profile["total"] }} posts)</p>

															<p v-if="profile['total'] > 5">
																<span
																	@click="viewAuthor(profile.posts[0].join.parent)"
																	class="morePostByAuthor"
																	:id="profile.posts[0].join.parent"
																	>View all posts</span
																>
															</p>

															<p
																style="min-height: 0"
																v-if="resultsProfile[profile.posts[0].join.parent]['segment'].length"
															>
																<span
																	v-for="segment in resultsProfile[profile.posts[0].join.parent][
																		'segment'
																	]"
																	v-bind:key="segment"
																	class="dynvibePostSegment"
																	style="margin-bottom: 5px; font-size: 0.9em; width: 100%"
																>
																	{{ segment }}
																</span>
															</p>
														</div>
													</div>

													<div
														v-if="!noData"
														class="col-xs-10"
														style="border-left: 1px solid #e6e6e6; padding-left: 0px; padding-right: 0px"
													>
														<authorstory
															:ref="'story-' + post._id"
															v-for="post in profile['posts']"
															v-bind:key="post._id"
															:post="post"
															:middle="middle"
														></authorstory>
													</div>
													<div v-else class="dynvibeLoading" style="min-height: 295px"></div>
												</div>
											</div>
										</div>
									</div>
									<div class="row dynvibePaginationGraphdetail">
										<div class="col-lg-12">
											<div style="float: right; margin-top: 10px">
												<pagination
													v-if="page >= 0"
													:page="page"
													:page-max="pageMax"
													@changepage="changePostPage($event)"
												></pagination>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import listprofilecircles from "@/components/globalVue/ListProfileCircles.vue";
import pagination from "@/components/globalVue/Pagination.vue";
import perpagesort from "@/components/globalVue/perpageSort.vue";
import authorstory from "@/components/posts/authorStory.vue";

export default {
	name: "graphDetails",
	props: {
		middle: {
			type: Boolean,
			default: () => false,
		},
		axios: {
			type: String,
			default: () => "",
		},
	},
	components: {
		listprofilecircles: listprofilecircles,
		pagination: pagination,
		perpagesort: perpagesort,
		authorstory: authorstory,
	},
	data() {
		return {
			show: false,
			totalPosts: 0,
			noData: true,
			posts: {},
			page: {},
			rangeStory: {},
			pageMax: {},
			totalProfiles: 0,
			profiles: {},
			author: {},
			resultsPosts: {},
			resultsProfile: {},
			authors: {},
			idauthor: null,
			from: {},
			tagclassSelected: "",
			tagclass: [
				{
					text: "ALL",
					value: "",
				},
				{
					text: "Brand",
					value: "brand",
				},
				{
					text: "People",
					value: "people",
				},
				{
					text: "Topics",
					value: "tag",
				},
			],
			orderBy: {},
			event: {},
			mode: {},
			word: {},
			postOptions: {
				page: 0,
				size: 20,
			},
			sizeBack: null,
			pageBack: 0,
			openTab: "stories",
		};
	},
	watch: {
		tagclassSelected() {
			if (this.show === true) {
				delete this.postOptions.mastertagEventWC;
				this.getDataWordCloud(this.word, this.event);
			}
		},
		show(newVal) {
			if (newVal === false) {
				this.totalPosts = 0;
				this.totalProfiles = 0;
				this.tagclassSelected = "";
				delete this.$store.getters.parameters.mastertagEvent;
				delete this.$store.getters.parameters.tagclassWC;
				delete this.$store.getters.parameters.mastertagEventWC;
				delete this.$store.getters.parameters.searchallwords;
			}
		},
	},
	methods: {
		getDataWordCloud(word = null, event = false, reloadWordcloudEvent = true, reset = false) {
			this.mode = "word";
			this.word = word;
			this.event = event;
			if (reset) {
				this.postOptions = {
					page: 0,
					size: 20,
				};
				this.$refs.perpagesort.range = 20;
				this.$refs.perpagesort.orderBy = "latest_published";
			}

			let params = {
				parameters: {},
				data: this.postOptions,
			};
			if (this.event === true) {
				if (!this.idauthor) {
					params.type = "eventsRelativePosts";
				}
				params.parameters.mastertagEvent = this.word;
			} else {
				params.parameters.searchallwords = this.word;
			}
			params.parameters = { ...this.$store.getters.parameters, ...params.parameters };
			this.fetchData(params, reloadWordcloudEvent);
			delete params.parameters.searchallwords;
			delete params.parameters.mastertagEvent;
			delete params.parameters.tagclassWC;
		},
		getDataStory(idProfile, middle = false) {
			this.mode = "story";
			this.event = false;
			this.idauthor = idProfile;
			this.postOptions.idauthor = idProfile;
			if (middle == true) {
				this.postOptions.middle = true;
			} else {
				this.postOptions.middle = false;
			}
			let parameters = this.$store.getters.parameters;
			parameters.type = "Profiles";
			let params = { parameters: parameters, data: this.postOptions };
			this.fetchData(params);
		},
		getDataGraph(event, reset = false) {
			if (reset) {
				this.postOptions = {
					page: 0,
					size: 20,
				};
				this.$refs.perpagesort.range = 20;
				this.$refs.perpagesort.orderBy = "latest_published";
			}
			this.mode = "graph";
			this.event = event;
			let data = this.postOptions;
			data.function = this.axios;

			let point = [event.point.name, event.point.y];
			if (!event.point.name) {
				point = [event.point.category.trim(), event.point.series.name];
			}

			let params = {
				parameters: this.$store.getters.parameters,
				data: data,
				point: point,
			};

			delete params.parameters.searchallwords;
			delete params.parameters.mastertagEvent;
			delete params.parameters.tagclassWC;

			this.fetchData(params);
		},
		fetchData(params, reloadWordcloudEvent = true) {
			this.show = true;
			this.noData = true;
			this.resultsPosts = {};

			this.$axios
				.get(this.$backendUrl + "graphDetailData", {
					params: params,
					paramsSerializer: (params) => {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((results) => {
					this.noData = false;
					this.totalPosts = results.data.totalPosts;
					this.posts = results.data.posts;
					this.page = parseInt(results.data.page);
					this.rangeStory = results.data.rangeStory;
					this.pageMax = parseInt(results.data.pageMax);
					this.totalProfiles = results.data.totalProfiles;
					this.profiles = results.data.profiles;
					this.author = results.data.author;
					this.resultsPosts = results.data.resultsPosts;
					if (results.data.orderBy === "authors") {
						this.resultsPosts = Object.entries(this.resultsPosts)
							.map((x) => x[1])
							.sort((a, b) => {
								return b.total - a.total;
							});
					}
					this.resultsProfile = results.data.resultsProfile;
					this.authors = results.data.authors;
					this.idauthor = results.data.idauthor;
					this.from = results.data.from;
					this.orderBy = results.data.orderBy === "desc" ? "latest_published" : results.data.orderBy;
					this.panel = results.data.panel;

					this.$nextTick(() => {
						if (this.$refs["profilescircles-" + this.axios]) {
							this.$refs["profilescircles-" + this.axios].loadComponent(this.$store.getters.parameters);
						}
						if (this.$refs.wordcloudEventsRelative && !this.postOptions.mastertagEventWC && reloadWordcloudEvent) {
							this.$refs.wordcloudEventsRelative.loadComponent(
								this.$store.getters.parameters,
								this.tagclassSelected,
								this.word
							);
						}
					});
				});
		},
		viewAuthor(idProfile) {
			this.sizeBack = parseInt(this.postOptions.size);
			this.pageBack = parseInt(this.postOptions.page);
			this.$refs.perpagesort.range = 20;
			delete this.postOptions.size;
			delete this.postOptions.page;
			this.page = 0;
			this.idauthor = idProfile;
			this.postOptions.idauthor = idProfile;
			if (this.mode === "graph") {
				this.getDataGraph(this.event);
			} else {
				this.getDataWordCloud(this.word, this.event);
			}
		},
		backToPreviousGraph() {
			this.idauthor = null;
			delete this.postOptions.idauthor;
			this.postOptions.size = this.sizeBack;
			this.postOptions.page = this.pageBack;
			this.$refs.perpagesort.range = this.sizeBack;
			this.priority = "authors";
			this.orderBy = "authors";
			if (this.mode === "graph") {
				this.getDataGraph(this.event);
			} else if (this.mode === "word") {
				this.getDataWordCloud(this.word, this.event);
				this.$nextTick(() => {
					if (this.$refs.wordcloudEventsRelative) {
						this.$refs.wordcloudEventsRelative.loadComponent(
							this.$store.getters.parameters,
							this.tagclassSelected,
							this.word,
							this.postOptions.mastertagEventWC
						);
					}
				});
			}
		},
		getHighlight(post) {
			return post.highlights ? post.highlights.filter((highlight) => highlight["panel"] === this.panel).length > 0 : false;
		},
		changeRangePage(range) {
			this.postOptions.size = range;
			this.postOptions.page = 0;

			if (this.mode === "graph") {
				this.getDataGraph(this.event);
			} else if (this.mode === "word") {
				this.getDataWordCloud(this.word, this.event, false);
			} else if (this.mode === "story") {
				this.getDataStory(this.idauthor);
			}
		},
		changeSortPage(sort) {
			if (this.orderBy) {
				if (this.orderBy !== "profiles") {
					this.postOptions.page = 0;
					this.postOptions.sort = { date: { order: sort } };
				} else {
					delete this.postOptions.sort;
					this.postOptions.page = 0;
					this.postOptions.type = "Posts";
				}
			} else {
				delete this.postOptions.sort;
			}
			if (this.mode === "graph") {
				this.getDataGraph(this.event);
			} else if (this.mode === "word") {
				this.getDataWordCloud(this.word, this.event, false);
			}
		},
		changePostPage(page) {
			this.postOptions.page = page;
			if (this.mode === "graph") {
				this.getDataGraph(this.event);
			} else if (this.mode === "word") {
				this.getDataWordCloud(this.word, this.event, false);
			} else if (this.mode === "story") {
				this.getDataStory(this.idauthor);
			}
		},
		selectTagClass() {
			delete this.postOptions.mastertagEventWC;
			this.getDataWordCloud(this.word, this.event);
		},
		reloadFromWordcloudEvent(word) {
			this.postOptions.page = 0;
			if (word) {
				this.postOptions.mastertagEventWC = word;
				let params = {
					parameters: this.$store.getters.parameters,
					data: this.postOptions,
				};
				this.fetchData(params);
			} else {
				delete this.postOptions.mastertagEventWC;
				this.getDataWordCloud(this.word, this.event, false);
			}
		},
		reloadInnerWordcloud() {
			if (this.$refs.wordcloudEventsRelative) {
				this.$refs.wordcloudEventsRelative.loadComponent(this.$store.getters.parameters, this.tagclassSelected, this.word);
			}
		},
	},
	computed: {
		profilesPointId() {
			return 0;
			// error with formattedWord , disabled for the moment
			/*if (this.event.point) {
			return this.event.point.id;
			} else {
			let formattedWord = this.word;

			if (/'/g.test(formattedWord)) {
			formattedWord = formattedWord.replace(/\'/g, "");
			}
			if (/\s/g.test(formattedWord)) {
			formattedWord = formattedWord.replace(/\s/g, "");
			}
			if (formattedWord[0] === "#") {
			return formattedWord.slice(1);
			} else {
			return formattedWord;
			}
			}*/
		},
	},
};
</script>

<style scoped>
.dynvibeGalleryProfilesTotal {
	display: none;
}

#dynvibeGraphDetails .dynvibeGalleryProfilesTotal {
	display: inline-block;
}

.dynvibeStoryListDetails {
	max-height: 457px;
	overflow: auto;
}

.dynvibeStoryListDetails .dynvibeStoryContenu > p {
	min-height: 134px;
	font-size: 12px;
	font-weight: 400;
}

.dynvibeStoryListDetailsTotalStories,
.dynvibeGalleryProfilesTotal {
	float: left;
	font-family: "Montserrat";
	font-size: 14px;
	font-weight: 700;
}

.dynvibeDetailsWordCloud > text:hover {
	cursor: pointer;
}

.postPicture {
	width: 130px;
	height: 130px;
	margin-right: 15px;
	display: block;
	background-position: center;
	background-size: cover;
}

.emptyPicture {
	width: 200px;
	height: 200px;
	margin-right: 15px;
}

.dynvibeStoryContenu p {
	min-height: 0;
}

.dynvibeToTranslateResult {
	word-wrap: break-word;
}

.graphDetailsTotal {
	display: inline-block;
}

#backToPreviousGraph {
	text-decoration: underline;
	outline: none;
	border: none;
	background: transparent;
}
</style>
